/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */
aucor_navigation(document.getElementById('primary-navigation'), {
  desktop_min_width: 890, // min width in pixels
  menu_toggle: '#menu-toggle' // selector for toggle
});

/**
 * Responsive videos
 */
fitvids();

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function (e) {

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function () {
      objectFitPolyfill();
    });

  });
}

// Due to fixed navigation, we need to offset the scroll position when clicking on anchor links
document.addEventListener("DOMContentLoaded", function () {
  var headerHeight = 200; // Height of the fixed header

  // Function to scroll to the element with adjusted offset
  function scrollToTarget(target) {
    if (target) {
      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }

  // Handle anchor link clicks
  var links = document.querySelectorAll('a[href*="#"]');
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.querySelector(this.hash);
      if (target) {
        event.preventDefault();
        scrollToTarget(target);
      }
    });
  });

  // Handle anchor in URL when page loads
  if (window.location.hash) {
    setTimeout(function () { // Delay to ensure page is fully loaded
      var target = document.querySelector(window.location.hash);
      if (target) {
        scrollToTarget(target);
      }
    }, 100); // Slight delay to make sure the DOM is fully rendered
  }
});

function setEqualHeights() {
  const titleContainers = document.querySelectorAll('.product-category__title-container');
  let maxHeight = 0;

  // Reset any inline height to get natural height
  titleContainers.forEach(container => {
    container.style.height = 'auto';
  });

  // Find the maximum height
  titleContainers.forEach(container => {
    const height = container.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Apply the maximum height to all containers
  titleContainers.forEach(container => {
    container.style.height = `${maxHeight}px`;
  });
}

// Run the function on DOM load
document.addEventListener('DOMContentLoaded', setEqualHeights);

// Reapply on window resize
window.addEventListener('resize', setEqualHeights);
